import styled, { css } from "styled-components";
import breakpoint from "styled-components-breakpoint";

const H1 = styled.h1`
  font-size: 1.4rem;
  margin-top: 0;
  text-transform: uppercase;
`;

const H2 = styled.h1`
  font-size: 1.2rem;
  margin-top: 0;
`;

const P = styled.p``;

const Section = styled.section.attrs({
  className: "section",
})`
  padding: 1rem;

  ${({ width }: { width?: number }) =>
    width &&
    css`
      max-width: ${width}rem;
    `};

  ${breakpoint("tablet")`
    background-color: #fff;
    border: 1px solid #dddfe2;
    border-radius: 0.2rem;
    margin: 1rem;
  `}
`;

const Button = styled.button`
  border: 1px solid #dddfe2;
  border-radius: 0.2rem;
  margin: 1rem 0;
  padding: 0.5rem;
`;

interface InputProps {
  paddingLeft: string;
}

const Label = styled.label`
  padding: 0.5rem;
  width: 6rem;
  text-align: left;
`;

const Input = styled.input`
  border: 1px solid #dddfe2;
  border-radius: 0.2rem;
  margin: ${(props: { noMargin?: boolean }) => (props.noMargin ? 0 : "1rem 0")};
  padding: 0.5rem;
`;

export { Button, H1, H2, Label, Input, P, Section };
